import React from 'react';

const styles: Record<string, React.CSSProperties> = {
  container: {
    padding: 32,
    textAlign: 'center',
  },
  errorIconBox: {
    margin: 48,
  },
  themeToggle: {
    position: 'fixed',
    top: 24,
    right: 24,
  },
};

export default styles;
